import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { isEmpty } from "lodash-es";
import { useMemo } from "react";
import { config } from "../../../../../../config";
import { useFlags } from "../../../../../../server/optimizely";
import { usePopover } from "../../../../../../utils/hooks/use-popover";
import { useClaims } from "../../../../../generic/hooks/use-claims";
import { AccountLimitsGrid } from "./account-limits-grid";
import { DebugFlagsGrid } from "./debug-flags-grid";
import { PermissionOverridesGrid } from "./permission-overrides-grid";
import "./debug.css";

import type { FC } from "react";

export const DebugButton: FC = () => {
  const {
    flags: { debug },
    flagsLoaded,
  } = useFlags("debug");

  const [, modal] = usePopover();
  const user = useClaims();

  const details = useMemo(() => {
    if (!user) return null;

    const supabase_url = new URL(user["http://changeengine.com/supabase_url"]);

    return {
      account_id: user["http://changeengine.com/account_id"],
      org_id: user.org_id,
      db: config.db_reverse[supabase_url.hostname] ?? supabase_url.hostname,
    };
  }, [user]);

  if (!flagsLoaded || !debug || isEmpty(details)) return null;

  return (
    <>
      <Button data-analytics-id="debug-modal-sidebar-btn" onClick={modal.handleOpen} fullWidth>
        Debug
      </Button>
      <Dialog open={modal.open} onClose={modal.handleClose} fullWidth>
        <DialogTitle>Debug Info</DialogTitle>
        <DialogContent>
          <Stack spacing={2} direction="column">
            {/* Details */}
            <Stack spacing={1} direction="column">
              <Typography variant="h6">Details</Typography>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Key</TableCell>
                      <TableCell align="right">Value</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.entries(details).map(([key, value]) => (
                      <TableRow key={key}>
                        <TableCell>{key}</TableCell>
                        <TableCell align="right">{value}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Stack>
            <AccountLimitsGrid />
            <PermissionOverridesGrid />

            <DebugFlagsGrid />
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
};
